module.exports = __webpack_public_path__ + "static/media/traffic-light-slow.c017a1b3.svg";